var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{staticClass:"ml-2",attrs:{"label":"Selecionar métodos pagamento depois"},model:{value:(_vm.is_without_payment),callback:function ($$v) {_vm.is_without_payment=$$v},expression:"is_without_payment"}}),(!_vm.is_without_payment)?[_c('EditOrderPayments',{ref:"form",attrs:{"order":_vm.order,"wholesale":""}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }